/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabContainer_comment = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "AllCommentsTabContainer_comment";
};
export type AllCommentsTabContainer_comment$data = AllCommentsTabContainer_comment;
export type AllCommentsTabContainer_comment$key = {
    readonly " $data"?: AllCommentsTabContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'f576259fdbd1b5053c372458203fdc4b';
export default node;
